import { erpApi } from "@/shared/axios"
import { urlBackend } from "@/shared/constants"
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces"
import { ISolicitudDeuda, ISolicitudDeudaParams, ISolicitudDeudaResp } from "@/shared/interfaces/erp/solicitud_deuda/solicitud_deuda.interface"
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils"
import { useUiStore } from "@/store/ui"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"


const { get, post, put } = erpApi()


///* Obtener solicitudes deuda
export const fetchGetSolicitudDeuda = (params: ISolicitudDeudaParams) => {
  return useQuery({
    queryKey: ['solicitudpasardeuda', ...Object.values(params || {})],
    queryFn: async () => {
      return await getSolicitudDeuda(params)
    },
    refetchOnWindowFocus: false,
  })
}

export const getSolicitudDeuda = (params: ISolicitudDeudaParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  return get<ISolicitudDeudaResp>(`${urlBackend}api/v1/solicitudpasardeuda/?${queryParams}`, true)
}

///* Crear una solicitud
export const fetchPostSolicitudDeuda = ({
  enableSuccessAlert = true

}: UseMutationsParams) => {

  const setAlert = useUiStore.getState().setAlert
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postSolicitudDeuda,
    onSuccess: (resp) => {
      queryClient.invalidateQueries({ queryKey: ['solicitudpasardeuda'] })

      enableSuccessAlert &&
        setAlert(true, resp.message, AlertSeverityEnum.success)
    },
    onSettled: () => {

    },
    onError: (error) => handleAxiosError(error)
  })
}
export const postSolicitudDeuda = (data: ISolicitudDeudaParams) => {
  return post<ISolicitudDeuda>(`${urlBackend}api/v1/solicitudpasardeuda/`, data, true)
}

///* Actualizar solicitud de deuda

export const fetchPutSolicitudDeuda = ({
  enableSuccessAlert = true

}: UseMutationsParams) => {

  const setAlert = useUiStore.getState().setAlert
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putSolicitudDeuda,
    onSuccess: (resp) => {

      queryClient.invalidateQueries({ queryKey: ['solicitudpasardeuda'] })

      enableSuccessAlert &&
        setAlert(true, resp.message, AlertSeverityEnum.success)
    },
    onSettled: () => {

    },
    onError: (error) => handleAxiosError(error)
  })
}
export const putSolicitudDeuda = (data: ISolicitudDeudaParams) => {
  return put<ISolicitudDeuda>(`${urlBackend}api/v1/solicitudpasardeuda/${data.id_solicitud_pasar_deuda}/`, data, true)
}
